export function isDashboardIndexPath(addressLink) {
    if (!addressLink) return false;
    return addressLink.replace(/\/+$/, "") === "/dashboard";
}
